import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_2 = { class: "col-span-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-semibold text-neutral-600" }, "Address Type", -1)
const _hoisted_4 = { class: "flex mt-5 space-x-3" }
const _hoisted_5 = { class: "col-span-12" }
const _hoisted_6 = { class: "col-span-6" }
const _hoisted_7 = { class: "col-span-6" }
const _hoisted_8 = { class: "col-span-6" }
const _hoisted_9 = { class: "col-span-6" }
const _hoisted_10 = { class: "col-span-12" }
const _hoisted_11 = { class: "col-span-6" }

import RadioGroup from "@/components/inputs/RadioGroup.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditPage',
  props: {
	form: {
		type: Object
	},
	optionAdressType: {
		type: Object
	},
	optionRegion: {
		type: Object
	},
	optionProvince: {
		type: Object
	},
	optionCityMunicipality: {
		type: Object
	},
	optionBarangay: {
		type: Object
	}
},
  setup(__props) {

const props = __props

const formData = ref({ ...props.form })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(RadioGroup, {
          options: __props.optionAdressType.data,
          name: "option_selected",
          modelValue: formData.value.address_type,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.address_type) = $event))
        }, null, 8, ["options", "modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(TextInput, {
        label: "Permanent Address",
        placeholder: "Permanent Address",
        name: "permanent_address",
        id: "permanent_address",
        modelValue: formData.value.permanent_address,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.permanent_address) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(MultiSelect, {
        searchable: "",
        options: __props.optionRegion.data,
        label: "Region",
        id: "region",
        name: "region",
        placeholder: "Select..",
        modelValue: formData.value.region,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.region) = $event))
      }, null, 8, ["options", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(MultiSelect, {
        searchable: "",
        options: __props.optionProvince.data,
        label: "Province",
        id: "province",
        name: "province",
        placeholder: "Select..",
        modelValue: formData.value.province,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.province) = $event))
      }, null, 8, ["options", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(MultiSelect, {
        searchable: "",
        options: __props.optionCityMunicipality.data,
        label: "City/Municipality/District",
        id: "city_municipality",
        name: "city_municipality",
        placeholder: "Select..",
        modelValue: formData.value.city_municipality,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.city_municipality) = $event))
      }, null, 8, ["options", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(MultiSelect, {
        searchable: "",
        options: __props.optionBarangay.data,
        label: "Barangay",
        id: "barangay",
        name: "barangay",
        placeholder: "Select..",
        modelValue: formData.value.barangay,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.barangay) = $event))
      }, null, 8, ["options", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(TextInput, {
        label: "Direction",
        placeholder: "Direction",
        name: "direction",
        id: "direction",
        modelValue: formData.value.directions,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.directions) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(TextInput, {
        type: "number",
        label: "Present Telephone",
        placeholder: "Present Telephone",
        name: "present_telephone",
        id: "present_telephone",
        modelValue: formData.value.present_telephone,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.present_telephone) = $event))
      }, null, 8, ["modelValue"])
    ])
  ]))
}
}

})